export default function Agelocme(agelocmeData) {
    this.code = agelocmeData && agelocmeData.code ? agelocmeData.code : null;
    this.label = agelocmeData && agelocmeData.label ? agelocmeData.label : null;
    this.name = agelocmeData && agelocmeData.name ? agelocmeData.name : null;
    this.calibration = agelocmeData ? agelocmeData.calibration === true : false;
    this.isCoreSolution = agelocmeData ? agelocmeData.isCoreSolution === true: false;

    this.isCustom = !(this.calibration);
    this.matches = function(obj) {
        obj = obj || {};
        return this.code === obj.code &&
            this.label === obj.label &&
            this.name === obj.name &&
            this.calibration === obj.calibration &&
            this.isCoreSolution === obj.isCoreSolution;
    };

    this.toJSON = function() {
        return {
            code: this.code,
            label: this.label,
            name: this.name,
            calibration: this.calibration,
            isCoreSolution: this.isCoreSolution
        }
    }
}
